module.exports = __webpack_public_path__ + "static/media/error.5a70f894.png";